<template>
  <div>
    <div ref="modal" style="display: none">
      <spinner-block v-model="dataProgress">
        <div v-if="debit_info && client_call && client_cards">
          <div class="mb-3">
            <div>
              <b>Оплата дебиторской задолженности</b>
            </div>
            Сумма задолженности будет списана с карты клиента. Обратите внимание что списание происходит без
            подтверждения клиентом.<br/>
            Убедитесь что списываете деньги с его счёта с его согласия.
          </div>

          <div class="mb-3">
            Будет списано <b>{{ +debit_info.squad + debit_info.service }}р</b>, из них:<br/>
            - {{ debit_info.squad }}р в пользу отряда<br/>
            - {{ debit_info.service }}р в пользу сервиса
          </div>

          <gui-select v-model="data.client_card_id" label="Карта клиента" name_prop="pan" :list="client_cards">
            <option value="" disabled>Выберите карту</option>
          </gui-select>


          <div class="mt-5">
            <button-save @click="save" text="Оплатить" :disabled="!(debit_info.squad >= 0 && debit_info.service>=0)"/>
            <button-cancel @click="fancyboxClose"/>
          </div>
        </div>
      </spinner-block>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data: function () {
    return {
      debit_info: null,
      client_call: null,
      client_cards: null,
      data: {
        id: null,
        client_card_id: null,
      },
      dataProgress: false,
      dataError: {},
    }
  },
  props: {},
  mounted() {
  },
  methods: {
    loadData(id) {
      axiosGetValue('/api/admin/client-call/debit-info', {id}, e => {
        this.debit_info = e.debit_info
        this.client_call = e.client_call
        this.client_cards = e.client_cards
        this.data.id = this.client_call.id

        this.client_cards.forEach(e => {
          if (e.is_main) {
            this.data.client_card_id = e.id
          }
        })

      }, e => this.dataProgress = e)
    },
    openModal(data_id) {
      if (data_id)
        this.loadData(data_id)

      this.fancybox(this.$refs.modal, () => {
        this.debit_info = null
        this.client_call = null
        this.client_cards = null
        this.data = {
          id: null,
          client_card_id: null,
        }
        clearErrorList(this.dataError)
      });
    },
    save() {
      $.alertConfirmForce({}, {
        ok: () => {
          axiosFast({
            url: route('/api/admin/client-call/debit-pay'),
            data: this.data,
            error: this.dataError,
            progress: e => this.dataProgress = e,
            result: () => {
              toastSuccess('Оплата прошла');
              this.$emit('update')
              this.fancyboxClose();
            },
          })
        }
      });
    }
  }
}
</script>